// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__11ANj","head":"Table_head__1uFR0","col":"Table_col__1q3XA"};